import * as React from 'react';
import { AlertType, Alert } from './Alert';

interface Props {
  message: string;
  closeAlert?: () => void;
  hideX?: boolean;
  style?: React.CSSProperties;
}

export class SuccessAlert extends React.Component<Props> {
  render() {
    const { message } = this.props;

    return (
      <Alert
        style={this.props.style}
        closeAlert={this.props.closeAlert}
        message={message}
        type={AlertType.Success}
        hideX={this.props.hideX}
      />
    );
  }
}
